import React from "react";
import { Col, Row } from "reactstrap";

import useResumoCotacao from "./useResumoCotacao";
import CardIndicador, { fmtBRL, fmtNumero, fmtRazao } from "./CardIndicador";
import "../indicadoresLinha.css";

// Cards do Cotado × Realizado na aba "Cotação" da Torre (PO1-3628). Os números
// vêm de GET /indicadores/gobid/cotado-realizado/resumo — o mesmo service dos
// blocos do indicador — e cada card abre a página com o mesmo período.
export const ROTA_INDICADOR = "/app/gobid/indicadores/cotado-realizado";

export function linkIndicador(periodo, bloco) {
  const extra = bloco ? `&bloco=${bloco}` : "";
  return `${ROTA_INDICADOR}?desde=${encodeURIComponent(periodo.desde)}&ate=${encodeURIComponent(periodo.ate)}&quebra=transportadora${extra}`;
}

const mensagemErro = (erro, semEmbarcador) => {
  if (semEmbarcador) return "Selecione um embarcador no cabeçalho";
  if (!erro) return null;
  const status = erro.response && erro.response.status;
  if (status === 403) return "Indicador disponível para o produto GoBID";
  return (erro.response && erro.response.data && erro.response.data.error) || "Não foi possível carregar o Cotado × Realizado";
};

export function montarCards(resumo, periodo) {
  const r = resumo || {};
  const acima = r.acimaDoCotado || {};
  const sem = r.semCotacao || {};
  const v = r.variacao || {};
  return {
    realizadoSobreCotado: {
      titulo: "Realizado ÷ cotado",
      valor: fmtRazao(r.realizadoSobreCotado),
      subtitulo: `${fmtBRL(r.freteRealizadoComCotacao)} realizado em ${fmtNumero(r.pedidosComCotacao)} pedido(s) cotados em ${fmtBRL(r.freteCotado)}`,
      icone: "tim-icons icon-money-coins",
      tom: r.realizadoSobreCotado !== null && r.realizadoSobreCotado !== undefined && r.realizadoSobreCotado > 1 ? "icon-danger" : "icon-success",
      link: linkIndicador(periodo, "cotado"),
      variacao: v.realizadoSobreCotado,
    },
    acimaDoCotado: {
      titulo: "Pedidos acima do cotado",
      valor: fmtNumero(acima.qtd),
      subtitulo: `${fmtBRL(acima.valor)} além do cotado no período`,
      icone: "tim-icons icon-alert-circle-exc",
      tom: "icon-danger",
      link: linkIndicador(periodo, "cotado"),
      variacao: v.acimaDoCotado ? v.acimaDoCotado.qtd : null,
    },
    semCotacao: {
      titulo: "Pedidos sem cotação",
      valor: fmtNumero(sem.qtd),
      subtitulo: `${fmtBRL(sem.freteRealizado)} de frete realizado sem cotação no GoBID`,
      icone: "tim-icons icon-paper",
      tom: "icon-warning",
      link: linkIndicador(periodo, "cotado"),
      variacao: v.semCotacao ? v.semCotacao.qtd : null,
    },
    destinosSemTabela: {
      titulo: "Destinos sem tabela",
      valor: fmtNumero(r.destinosSemTabela),
      subtitulo: "Transportadora × cidade com CT-e sem cálculo ou cotação spot",
      icone: "tim-icons icon-map-big",
      tom: "icon-info",
      link: linkIndicador(periodo, "cobertura"),
      variacao: v.destinosSemTabela,
    },
  };
}

export const CARDS = ["realizadoSobreCotado", "acimaDoCotado", "semCotacao", "destinosSemTabela"];

// `somente`: id de um card (widget do Meu Painel). Sem `somente`: a linha com os 4.
export default function CardsCotadoRealizado({ deferLoad = false, onRegisterFetch, somente }) {
  const { dados, carregando, erro, periodo, semEmbarcador } = useResumoCotacao({ deferLoad, onRegisterFetch });
  const resumo = dados && dados.cotado;
  const erroTexto = mensagemErro((dados && dados.erroCotado) || erro, semEmbarcador);
  const cards = montarCards(resumo, periodo);

  if (somente) {
    const c = cards[somente];
    return c ? <CardIndicador {...c} carregando={carregando} erro={erroTexto} /> : null;
  }
  return (
    <Row className="indicadores-linha">
      {CARDS.map((id) => (
        <Col lg md="6" key={id}>
          <CardIndicador {...cards[id]} carregando={carregando} erro={erroTexto} />
        </Col>
      ))}
    </Row>
  );
}

// Widgets do Meu Painel: um por card (PO1-3628, decisão 3 do kickoff: liberação pelo produto GOBID).
export const CardRealizadoSobreCotado = (props) => <CardsCotadoRealizado {...props} somente="realizadoSobreCotado" />;
export const CardAcimaDoCotado = (props) => <CardsCotadoRealizado {...props} somente="acimaDoCotado" />;
export const CardSemCotacao = (props) => <CardsCotadoRealizado {...props} somente="semCotacao" />;
export const CardDestinosSemTabela = (props) => <CardsCotadoRealizado {...props} somente="destinosSemTabela" />;
